import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton } from '@mui/material';
import { useCopyToClipboard } from 'core/hooks/useCopyToClipboard';
import { getGeolocationString } from 'core/utils/orderUtils';
import { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import StoreContext from 'stores/context/StoreContext';
import type { GeolocationCoordinates } from 'models/order/order';
import type { FC } from 'react';

interface CoordinatesProps {
  data: GeolocationCoordinates;
}

const Coordinates: FC<CoordinatesProps> = observer(({ data }) => {
  const [_, copy] = useCopyToClipboard();

  const { notifyStore } = useContext(StoreContext);

  const geolocationCopyClickHandler = (): void => {
    void (
      !isNil(data) &&
      copy(getGeolocationString(data))
        .catch((err) => {
          notifyStore.showNotify(err, 'error');
          throw err;
        })
        .then(() => {
          notifyStore.showNotify('Координаты скопированы в буфер обмена', 'info');
          return true;
        })
    );
  };

  return (
    <span>
      {getGeolocationString(data)}
      <IconButton
        aria-label='Copy coordinates'
        size='small'
        onClick={geolocationCopyClickHandler}>
        <ContentCopyIcon fontSize='inherit' />
      </IconButton>
    </span>
  );
});

export default Coordinates;
